<template>
  <div class="uesrLicenseStyles">
    <h1>用户注册及使用协同宝App隐私协议</h1>
    <uesrLicenseVue class="content" />
  </div>
</template>
<script>
import uesrLicenseVue from "./compontent/uesrLicense.vue";
export default {
  components: { uesrLicenseVue }
};
</script>
<style lang="scss" scoped>
.uesrLicenseStyles{
  width: 100%;
  padding: 10px;
  overflow-y: auto;
  h1{
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    margin: 10px 0;
  }
  .content{
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
